import { useMonitor } from '../use-monitor';

export function useMonitorViewIssueLoad() {
  return useMonitor('view-issue-load');
}
